var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 4.75C13.0025 4.75 13.13 4.7575 13.25 4.7725V1.6525C13.25 0.88 12.62 0.25 11.8475 0.25H1.9025C1.13 0.25 0.5 0.88 0.5 1.6525V9.3475C0.5 10.12 1.13 10.75 1.9025 10.75H9.2C8.915 10.1875 8.75 9.55 8.75 8.875C8.75 6.595 10.595 4.75 12.875 4.75ZM6.8 6.25L2 3.3925V1.75H2.1725L6.8075 4.51L11.555 1.75H11.75V3.37L6.8 6.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.25L12.1925 7.3075L13.3775 8.5H10.25V10H13.3775L12.1925 11.1925L13.25 12.25L16.25 9.25L13.25 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.87a12d8bcc7229456037fd616793017e.svg";
export { ForwardRef as ReactComponent };